import React from 'react';
import Hero from './components/itep/Hero';
import Main from './components/itep/Main';

const Itep = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Itep;